(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["carrousel-produits"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-carousel-section')) {
    class ProductCarouselSection extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.prevBtn = this.querySelector('[data-prev]');
        this.nextBtn = this.querySelector('[data-next]');
        this.currentEl = this.querySelector('[data-current]');
        if (!this.track || !this.slides.length) return;

        this.onPrev = () => this.go(-1);
        this.onNext = () => this.go(1);
        this.onScroll = () => {
          cancelAnimationFrame(this.raf);
          this.raf = requestAnimationFrame(() => this.update());
        };
        this.prevBtn && this.prevBtn.addEventListener('click', this.onPrev);
        this.nextBtn && this.nextBtn.addEventListener('click', this.onNext);
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll);

        this.bindSwatches();
        this.update();
      }

      disconnectedCallback() {
        this.prevBtn && this.prevBtn.removeEventListener('click', this.onPrev);
        this.nextBtn && this.nextBtn.removeEventListener('click', this.onNext);
        this.track && this.track.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
      }

      step() {
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        return this.slides[0].getBoundingClientRect().width + gap;
      }

      index() {
        return Math.round(this.track.scrollLeft / this.step());
      }

      go(dir) {
        const i = Math.max(0, Math.min(this.slides.length - 1, this.index() + dir));
        this.track.scrollTo({
          left: this.slides[i].offsetLeft - this.slides[0].offsetLeft,
          behavior: 'smooth'
        });
      }

      update() {
        const max = this.track.scrollWidth - this.track.clientWidth;
        if (this.currentEl) this.currentEl.textContent = Math.min(this.index() + 1, this.slides.length);
        if (this.prevBtn) this.prevBtn.disabled = this.track.scrollLeft <= 2;
        if (this.nextBtn) this.nextBtn.disabled = this.track.scrollLeft >= max - 2;
      }

      bindSwatches() {
        this.querySelectorAll('[data-variant-image]').forEach((swatch) => {
          const card = swatch.closest('.pc-card');
          const img = card && card.querySelector('[data-main-image]');
          if (!img) return;
          if (!img.dataset.originalSrc) {
            img.dataset.originalSrc = img.currentSrc || img.src;
            img.dataset.originalSrcset = img.getAttribute('srcset') || '';
          }
          const show = () => {
            img.removeAttribute('srcset');
            img.src = swatch.dataset.variantImage;
          };
          const reset = () => {
            img.src = img.dataset.originalSrc;
            if (img.dataset.originalSrcset) img.setAttribute('srcset', img.dataset.originalSrcset);
          };
          swatch.addEventListener('mouseenter', show);
          swatch.addEventListener('focus', show);
          swatch.addEventListener('mouseleave', reset);
          swatch.addEventListener('blur', reset);
        });
      }
    }
    customElements.define('product-carousel-section', ProductCarouselSection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sections-shop-the-look"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('shop-the-look')) {
    class ShopTheLook extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.prevBtn = this.querySelector('[data-prev]');
        this.nextBtn = this.querySelector('[data-next]');
        this.dotsWrap = this.querySelector('[data-dots]');
        this.hotspots = Array.from(this.querySelectorAll('[data-hotspot]'));
        if (!this.track || !this.slides.length) return;

        this.onScroll = () => {
          cancelAnimationFrame(this.raf);
          this.raf = requestAnimationFrame(() => this.update());
        };
        this.onResize = () => { this.buildDots(); this.update(); };
        this.onDocClick = (e) => { if (!e.target.closest('[data-hotspot]')) this.closeAll(); };
        this.onKey = (e) => { if (e.key === 'Escape') this.closeAll(); };

        this.prevBtn.addEventListener('click', () => this.go(this.index() - 1));
        this.nextBtn.addEventListener('click', () => this.go(this.index() + 1));
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onResize);
        document.addEventListener('click', this.onDocClick);
        document.addEventListener('keydown', this.onKey);

        this.hotspots.forEach((hs) => {
          const btn = hs.querySelector('.stl-hs__dot');
          btn.addEventListener('click', (e) => {
            e.stopPropagation();
            const open = hs.classList.contains('is-open');
            this.closeAll();
            if (!open) this.open(hs);
          });
        });

        // Éditeur de thème : sélectionner un bloc affiche le look / ouvre le point
        this.addEventListener('shopify:block:select', (e) => {
          const el = e.target;
          if (el.matches('[data-hotspot]')) {
            const slide = el.closest('[data-slide]');
            this.go(this.slides.indexOf(slide), 'instant');
            this.closeAll();
            this.open(el);
          } else if (el.matches('[data-slide]')) {
            this.go(this.slides.indexOf(el), 'instant');
          }
        });

        this.buildDots();
        this.update();
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.onResize);
        document.removeEventListener('click', this.onDocClick);
        document.removeEventListener('keydown', this.onKey);
      }

      open(hs) {
        hs.classList.add('is-open');
        hs.querySelector('.stl-hs__dot').setAttribute('aria-expanded', 'true');
      }

      closeAll() {
        this.hotspots.forEach((hs) => {
          hs.classList.remove('is-open');
          hs.querySelector('.stl-hs__dot').setAttribute('aria-expanded', 'false');
        });
      }

      step() {
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        return this.slides[0].getBoundingClientRect().width + gap;
      }

      visible() {
        return Math.max(1, Math.floor((this.track.clientWidth + 2) / this.step()));
      }

      pages() {
        return Math.max(1, this.slides.length - this.visible() + 1);
      }

      index() {
        return Math.round(this.track.scrollLeft / this.step());
      }

      go(i, behavior = 'smooth') {
        const pages = this.pages();
        if (i < 0) i = pages - 1;          // boucle
        if (i > pages - 1) i = 0;
        this.closeAll();
        this.track.scrollTo({
          left: this.slides[i].offsetLeft - this.slides[0].offsetLeft,
          behavior
        });
      }

      buildDots() {
        if (!this.dotsWrap) return;
        const pages = this.pages();
        if (this.dotsWrap.children.length === pages) return;
        this.dotsWrap.innerHTML = '';
        for (let i = 0; i < pages; i++) {
          const b = document.createElement('button');
          b.type = 'button';
          b.setAttribute('aria-label', `Look ${i + 1}`);
          b.addEventListener('click', () => this.go(i));
          this.dotsWrap.appendChild(b);
        }
      }

      update() {
        const pages = this.pages();
        const i = Math.min(this.index(), pages - 1);
        Array.from(this.dotsWrap.children).forEach((d, n) =>
          d.setAttribute('aria-current', n === i ? 'true' : 'false')
        );
        const hide = pages <= 1;
        this.prevBtn.hidden = hide;
        this.nextBtn.hidden = hide;
      }
    }
    customElements.define('shop-the-look', ShopTheLook);
  }

  } catch(e) { console.error(e); }
})();
})();
